import { useState } from 'react';

import { TBedrockAgentRefineMode } from '@cloud-wave/neon-common-lib';

import { TActionID } from '../components/IQActionsMenu/constants/IQActionItems';

export const useIQActionMenu = ({ resetIQApiState }: { resetIQApiState: () => void }) => {
  const [iqInput, setIQInput] = useState<string | null>(null);
  const [isActionMenuOpen, setIsActionMenuOpen] = useState(false);

  // Action / Modes
  const [selectedAction, setSelectedAction] = useState<TActionID | null>(null);
  const [selectedMode, setSelectedMode] = useState<TBedrockAgentRefineMode | null>(null);

  const resetIQActionMenuState = () => {
    resetIQApiState();
    setSelectedAction(null);
    setSelectedMode(null);
    setIQInput(null);
  };

  const closeActionMenu = () => {
    resetIQActionMenuState();
    setIsActionMenuOpen(false);
  };

  return {
    actions: {
      openActionMenu: () => setIsActionMenuOpen(true),
      selectAction: (item: TActionID | null) => setSelectedAction(item),
      selectMode: (mode: TBedrockAgentRefineMode | null) => setSelectedMode(mode),
      setIQInput: (text: string | null) => setIQInput(text),
      closeActionMenu,
      resetIQActionMenuState,
    },
    state: {
      isActionMenuOpen,
      selectedAction,
      selectedMode,
      iqInput,
    },
  };
};
